import { JobPriorityType, JobTaskStatusType, JobType } from '@/enum'
import { JobAssociatedAsset, JobTask } from './jobs'
import { getJobStatusColor } from '@/utils/helpers'
import AssignedEmployee from './employees/AssignedEmployee'
import type { IAssignedEmployee, IJobAssociatedAsset } from '@/interfaces'

class CalendarEvent {
  id: string
  title: string
  start: Date | null
  end: Date | null
  color: string
  employees?: IAssignedEmployee[]
  draggable: boolean
  type: JobType
  jobNumber: string | number
  jobId: string
  status: JobTaskStatusType
  classNames: string[]
  textColor: string
  startEditable: boolean
  durationEditable: boolean
  allDay?: boolean
  priority?: JobPriorityType
  asset: IJobAssociatedAsset

  constructor(event: JobTask) {
    const eventStartDate = event.dueAt
    // const eventStartDate = event.startedAt ?? event.scheduledAt

    this.id = event.id!
    this.title = event.job?.title || ''
    this.start = eventStartDate ? new Date(eventStartDate) : null
    this.end =
      event.completedAt || event.dueAt ? new Date((event.completedAt || event.dueAt)!) : null
    // this.start = eventStartDate ? new Date(eventStartDate) : null
    // this.end =
    //   event.completedAt || event.dueAt ? new Date((event.completedAt || event.dueAt)!) : null
    this.asset = new JobAssociatedAsset(event.job?.asset)
    this.jobId = event.jobId
    this.color = getJobStatusColor(event.status)
    this.employees = event.employees?.map(
      (assignedEmployee: any) => new AssignedEmployee(assignedEmployee)
    )
    this.draggable =
      [JobTaskStatusType.OPEN, JobTaskStatusType.SCHEDULED].includes(event.status) &&
      this.isAssetAvaiable()
    this.type = event.job?.type!
    this.jobNumber = event.number.toString()
    this.status = event.status
    this.classNames = ['bg-transparent border-0']
    this.textColor = '#000000'
    this.startEditable =
      [JobTaskStatusType.OPEN, JobTaskStatusType.SCHEDULED].includes(event.status) &&
      this.isAssetAvaiable()
    this.durationEditable = event.status !== JobTaskStatusType.COMPLETED
    this.priority = event.job?.priority
  }

  isAssetAvaiable() {
    const { vehicle, machine, equipment } = this.asset
    return !(vehicle.archivedAt || machine.archivedAt || equipment.archivedAt)
  }
}

export default CalendarEvent
